import styled from 'styled-components';

import { fontStyles, palette } from 'theme';
import ExternTitle from 'components/ExternTitle';

export const Title = styled(ExternTitle)`
  margin-bottom: 15px;
  @media (max-width: 991px) {
    margin-bottom: 5px;
  }
`;

export const Preamble = styled.p`
  ${fontStyles.text}
  background-color: ${palette.gray};
  border: 2px solid ${palette.black};
  padding: 5px 10px;
  margin-bottom: 60px;
`;

export const Version = styled.h2`
  ${fontStyles.titleH4}
  line-height: 45px;
  border: solid ${palette.black};
  border-width: 2px 0;
  margin: 5px 0 15px;
  @media (max-width: 991px) {
    margin: 0 0 15px;
    border-width: 2px 0 0;
    line-height: 1.25;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 15px;
  width: 100%;
`;
